var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenderIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_11555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 15.934C9.11608 15.6786 7.3993 14.7172 6.197 13.2443C4.99469 11.7714 4.39658 9.8969 4.52361 7.99985C4.65064 6.10279 5.49333 4.32475 6.88128 3.0253C8.26922 1.72585 10.0988 1.00195 12.0002 1C13.9038 0.998168 15.7369 1.72028 17.1278 3.01993C18.5188 4.31959 19.3634 6.09953 19.4906 7.99891C19.6178 9.89829 19.018 11.775 17.8127 13.2485C16.6075 14.722 14.887 15.682 13.0002 15.934V18H18.0002V20H13.0002V24H11.0002V20H6.00015V18H11.0002V15.934V15.934ZM12.0002 14C13.4588 14 14.8578 13.4205 15.8892 12.3891C16.9207 11.3576 17.5002 9.95869 17.5002 8.5C17.5002 7.04131 16.9207 5.64237 15.8892 4.61092C14.8578 3.57947 13.4588 3 12.0002 3C10.5415 3 9.14251 3.57947 8.11106 4.61092C7.07961 5.64237 6.50015 7.04131 6.50015 8.5C6.50015 9.95869 7.07961 11.3576 8.11106 12.3891C9.14251 13.4205 10.5415 14 12.0002 14V14Z",
    fill: "#09121F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_11555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderIcon1);
export default __webpack_public_path__ + "static/media/genderIcon1.7437b16894fae0b481dcb6c3c0063e2c.svg";
export { ForwardRef as ReactComponent };